export function Loading({ label = 'Cargando…' }: { label?: string }) {
  return (
    <div className="loading t-meta" role="status" aria-live="polite">
      {label}
    </div>
  );
}
